import script from "./ChainInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ChainInfo.vue?vue&type=script&setup=true&lang=js"

import "./ChainInfo.vue?vue&type=style&index=0&id=60eaaaa8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60eaaaa8"]])

export default __exports__